import { render, staticRenderFns } from "./AssignmentListPage.vue?vue&type=template&id=5eb1c33b&"
import script from "./AssignmentListPage.vue?vue&type=script&lang=ts&"
export * from "./AssignmentListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports